"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerAccountGroup = exports.TransactionType = exports.TAccountIterable = exports.ExpenseAccounts = exports.CurrentLiabilityAccounts = exports.LongTermLiabilityAccounts = exports.EquityAccounts = exports.LongTermAssetAccounts = exports.CurrentAssetAccounts = exports.AccountSubCategories = exports.AccountCategories = void 0;
/**
 * Account definitions
 *
 * Fundamental equation:
 * Assets = Liabilities + Equity
 */
// Unused, but keeping definition
var AccountCategories;
(function (AccountCategories) {
    AccountCategories["Liability"] = "liability";
    AccountCategories["Asset"] = "asset";
    AccountCategories["Equity"] = "equity";
})(AccountCategories || (exports.AccountCategories = AccountCategories = {}));
// Unused, but keeping definition
var AccountSubCategories;
(function (AccountSubCategories) {
    AccountSubCategories["CurrentLiability"] = "shortTermLiability";
    AccountSubCategories["LongTermLiability"] = "longTermLiability";
})(AccountSubCategories || (exports.AccountSubCategories = AccountSubCategories = {}));
var CurrentAssetAccounts;
(function (CurrentAssetAccounts) {
    CurrentAssetAccounts["Cash"] = "cash";
})(CurrentAssetAccounts || (exports.CurrentAssetAccounts = CurrentAssetAccounts = {}));
var LongTermAssetAccounts;
(function (LongTermAssetAccounts) {
    /**
     * This account tracks the principal amount that the Lender owes to the
     * Admin Agent as they fronted their amount for a draw.
     *
     * Treating as "Long Term" to follow suit with its counter part of
     * "AdminAgentPrincipalPayable" (comments below for context).
     */
    LongTermAssetAccounts["AdminAgentPrincipalReceivable"] = "adminAgentPrincipalReceivable";
})(LongTermAssetAccounts || (exports.LongTermAssetAccounts = LongTermAssetAccounts = {}));
var EquityAccounts;
(function (EquityAccounts) {
    EquityAccounts["ShareholdersEquity"] = "shareholdersEquity";
})(EquityAccounts || (exports.EquityAccounts = EquityAccounts = {}));
var LongTermLiabilityAccounts;
(function (LongTermLiabilityAccounts) {
    LongTermLiabilityAccounts["LongTermDebt"] = "longTermDebt";
    /**
     * This account tracks the principal amount that the Admin Agent fronts
     * for a lender, as a lender may not instantly provide the funds for a draw.
     * It's important to include this account as part of "Principal Balance"
     * since this balance basically reflects the "long term debt" that the
     * lender has the Admin Agent fronting for them.
     *
     * Our "current" accounts don't follow typical accounting standards, so
     * while we expect to pay this account off within a year, this account doesn't
     * have an associated "expense" account, which is what we generally treat our
     * current accounts for.
     */
    LongTermLiabilityAccounts["AdminAgentPrincipalPayable"] = "adminAgentPrincipalPayable";
})(LongTermLiabilityAccounts || (exports.LongTermLiabilityAccounts = LongTermLiabilityAccounts = {}));
var CurrentLiabilityAccounts;
(function (CurrentLiabilityAccounts) {
    CurrentLiabilityAccounts["AccruedAccountBankFee"] = "accruedAccountBankFee";
    CurrentLiabilityAccounts["AccruedAdminAgentFee"] = "accruedAdminAgentFee";
    CurrentLiabilityAccounts["AccruedAdminAgentSkimFee"] = "accruedAdminAgentSkimFee";
    CurrentLiabilityAccounts["AccruedAdminFee"] = "accruedAdminFee";
    CurrentLiabilityAccounts["AccruedBackupServicingFee"] = "accruedBackupServicingFee";
    CurrentLiabilityAccounts["AccruedCollateralAgentFee"] = "accruedCollateralAgentFee";
    CurrentLiabilityAccounts["AccruedCollateralManagementFee"] = "accruedCollateralManagementFee";
    CurrentLiabilityAccounts["AccruedCollectionAccountFee"] = "accruedCollectionAccountFee";
    CurrentLiabilityAccounts["AccruedCommitmentFee"] = "accruedCommitmentFee";
    CurrentLiabilityAccounts["AccruedCustodianFee"] = "accruedCustodianFee";
    CurrentLiabilityAccounts["AccruedDrawFee"] = "accruedDrawFee";
    CurrentLiabilityAccounts["AccruedInterest"] = "accruedInterest";
    CurrentLiabilityAccounts["AccruedIndentureTrusteeFee"] = "accruedIndentureTrusteeFee";
    CurrentLiabilityAccounts["AccruedOriginationFee"] = "accruedOriginationFee";
    CurrentLiabilityAccounts["AccruedOtherFee"] = "accruedOtherFee";
    CurrentLiabilityAccounts["AccruedPayingAgentFee"] = "accruedPayingAgentFee";
    CurrentLiabilityAccounts["AccruedServicingFee"] = "accruedServicingFee";
    CurrentLiabilityAccounts["AccruedTrustAccountFee"] = "accruedTrustAccountFee";
    CurrentLiabilityAccounts["AccruedUnusedInterest"] = "accruedUnusedInterest";
    CurrentLiabilityAccounts["AccruedUtilizationAdditionalInterest"] = "accruedUtilizationAdditionalInterest";
    CurrentLiabilityAccounts["AccruedVerificationAgentFee"] = "accruedVerificationAgentFee";
})(CurrentLiabilityAccounts || (exports.CurrentLiabilityAccounts = CurrentLiabilityAccounts = {}));
var ExpenseAccounts;
(function (ExpenseAccounts) {
    ExpenseAccounts["AccountBankFeeExpense"] = "accountBankFeeExpense";
    ExpenseAccounts["AdminAgentFeeExpense"] = "adminAgentFeeExpense";
    ExpenseAccounts["AdminFeeExpense"] = "adminFeeExpense";
    ExpenseAccounts["AdminAgentSkimFeeExpense"] = "adminAgentSkimFeeExpense";
    ExpenseAccounts["BackupServicingFeeExpense"] = "backupServicingFeeExpense";
    ExpenseAccounts["CollateralAgentFeeExpense"] = "collateralAgentFeeExpense";
    ExpenseAccounts["CollateralManagementFeeExpense"] = "collateralManagementFeeExpense";
    ExpenseAccounts["CollectionAccountFeeExpense"] = "collectionAccountFeeExpense";
    ExpenseAccounts["CommitmentFeeExpense"] = "commitmentFeeExpense";
    ExpenseAccounts["CustodianFeeExpense"] = "custodianFeeExpense";
    ExpenseAccounts["DrawFeeExpense"] = "drawFeeExpense";
    ExpenseAccounts["InterestExpense"] = "interestExpense";
    ExpenseAccounts["IndentureTrusteeFeeExpense"] = "indentureTrusteeFeeExpense";
    ExpenseAccounts["OriginationFeeExpense"] = "originationFeeExpense";
    ExpenseAccounts["OtherFeeExpense"] = "otherFeeExpense";
    ExpenseAccounts["PayingAgentFeeExpense"] = "payingAgentFeeExpense";
    ExpenseAccounts["ServicingFeeExpense"] = "servicingFeeExpense";
    ExpenseAccounts["TrustAccountFeeExpense"] = "trustAccountFeeExpense";
    ExpenseAccounts["UnusedInterestExpense"] = "unusedInterestExpense";
    ExpenseAccounts["UtilizationAdditionalInterestExpense"] = "utilizationAdditionalInterestExpense";
    ExpenseAccounts["VerificationAgentFeeExpense"] = "verificationAgentFeeExpense";
})(ExpenseAccounts || (exports.ExpenseAccounts = ExpenseAccounts = {}));
exports.TAccountIterable = [
    ...Object.values(CurrentAssetAccounts),
    ...Object.values(CurrentLiabilityAccounts),
    ...Object.values(LongTermLiabilityAccounts),
    ...Object.values(EquityAccounts),
    ...Object.values(ExpenseAccounts),
];
/**
 * Transactions and entries
 */
var TransactionType;
(function (TransactionType) {
    TransactionType["CollectionsRecycle"] = "collectionsRecycle";
    TransactionType["CollectionsPaydown"] = "collectionsPaydown";
    TransactionType["CurePaydown"] = "curePaydown";
    // Interest related transactions
    TransactionType["DailyAccrual"] = "dailyAccrual";
    TransactionType["ReverseInterestAccrual"] = "reverseInterestAccrual";
    TransactionType["DecreaseCurrentLiability"] = "decreaseCurrentLiability";
    TransactionType["DecreaseExpensePayment"] = "decreaseExpensePayment";
    TransactionType["DecreaseOutstandingLoanBalance"] = "decreaseOutstandingLoanBalance";
    TransactionType["DrawRequest"] = "drawRequest";
    TransactionType["ExpensePayment"] = "expensePayment";
    TransactionType["IncreaseCurrentLiability"] = "increaseCurrentLiability";
    TransactionType["IncreaseExpensePayment"] = "increaseExpensePayment";
    TransactionType["IncreaseOutstandingLoanBalance"] = "increaseOutstandingLoanBalance";
    TransactionType["ReconciliationAdjustment"] = "reconciliationAdjustment";
    TransactionType["ZeroCurrentLiabilities"] = "zeroCurrentLiabilities";
    TransactionType["TransferPrincipalBalance"] = "transferPrincipalBalance";
    // Invoice related transactions
    TransactionType["InvoiceLoanPayment"] = "invoiceLoanPayment";
    TransactionType["ReverseInvoiceLoanPayment"] = "reverseInvoiceLoanPayment";
    TransactionType["InterestCapitalization"] = "interestCapitalization";
    TransactionType["ReverseInterestCapitalization"] = "reverseInterestCapitalization";
    TransactionType["InvoiceFacilityPayment"] = "invoiceFacilityPayment";
    TransactionType["ReverseInvoiceFacilityPayment"] = "reverseInvoiceFacilityPayment";
    /**
     * Transactions related to Admin Agent fronting money for the loan's
     * lender during a draw request
     */
    TransactionType["AdminAgentPrincipalLending"] = "adminAgentPrincipalLending";
    TransactionType["AdminAgentPrincipalPaydown"] = "adminAgentPrincipalPaydown";
    TransactionType["ReverseAdminAgentPrincipalPaydown"] = "reverseAdminAgentPrincipalPaydown";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var LedgerAccountGroup;
(function (LedgerAccountGroup) {
    LedgerAccountGroup["OutstandingLedger"] = "outstandingLedger";
    LedgerAccountGroup["ExpensesFees"] = "expensesFees";
})(LedgerAccountGroup || (exports.LedgerAccountGroup = LedgerAccountGroup = {}));
//# sourceMappingURL=Accounting.js.map